import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
import _imports_1 from './../../assets/images/two/swiper_bg.png';
const _withScopeId = n => (_pushScopeId("data-v-2be1d449"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-bannerSwiperTwo-logo-div"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "com-bannerSwiperTwo-logo-com"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "com-bannerSwiperTwo-logo-img",
  alt: "",
  src: _imports_0
})])], -1));
const _hoisted_2 = {
  class: "com-bannerSwiperTwo-con"
};
const _hoisted_3 = {
  class: "com-bannerSwiperTwo-slide-div"
};
const _hoisted_4 = {
  class: "com-bannerSwiperTwo-top-div"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-bannerSwiperTwo-top-bg-div"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "com-bannerSwiperTwo-top-bg-img",
  alt: "",
  src: _imports_1
})], -1));
const _hoisted_6 = {
  class: "com-bannerSwiperTwo-top-con"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "com-bannerSwiperTwo-item-div"
};
const _hoisted_9 = {
  class: "com-bannerSwiperTwo-item-img-div"
};
const _hoisted_10 = {
  class: "com-bannerSwiperTwo-item-cover-div"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "com-bannerSwiperTwo-item-name"
};
const _hoisted_13 = {
  class: "com-bannerSwiperTwo-item-model"
};
const _hoisted_14 = {
  class: "com-bannerSwiperTwo-item-summary"
};
const _hoisted_15 = {
  class: "com-bannerSwiperTwo-item-summary-top"
};
const _hoisted_16 = {
  class: "com-bannerSwiperTwo-item-summary-bottom"
};
const _hoisted_17 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_swiper_two = _resolveComponent("swiper-two");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", {
    class: "com-bannerSwiperTwo-box",
    style: _normalizeStyle({
      height: $data.imgHeight
    })
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
    ref: "vanTabs",
    active: $data.tabActive,
    "onUpdate:active": _cache[2] || (_cache[2] = $event => $data.tabActive = $event),
    shrink: true
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (item, index) => {
      return _openBlock(), _createBlock(_component_van_tab, {
        title: `${item.name}`,
        name: item.value,
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          class: _normalizeClass(["com-bannerSwiperTwo-top-title", {
            'text-focus-in': $data.showText
          }])
        }, _toDisplayString($data.dataArr[item.name][$data.actives[index]]?.title), 3), _createElementVNode("i", {
          class: "iconfont icon-tianjia com-bannerSwiperTwo-top-title-iconfont",
          onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.handleMouseEnter && $options.handleMouseEnter(...args)),
          onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.handleMouseLeave && $options.handleMouseLeave(...args)),
          onClick: $event => $options.toFeature(index)
        }, null, 40, _hoisted_7)])]), _createVNode(_component_swiper_two, {
          class: "com-bannerSwiperTwo-swiper-div",
          ref_for: true,
          ref: `swiperTwo_${index}`,
          dataArr: $data.dataArr[item.name],
          slidesPerView: $options.slidesPerViewFun($data.dataArr[item.name].length),
          initialSlide: $options.initialSlideFun($data.dataArr[item.name].length),
          onSlideChangeTransitionStart: $options.slideChangeTransitionStart,
          onSlideChangeTransitionEnd: $event => $options.slideChangeTransitionEnd(index, $event)
        }, {
          default: _withCtx(slotProps => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_van_image, {
            id: `image_${index}_${slotProps.index}`,
            class: _normalizeClass(["com-bannerSwiperTwo-item-img", {
              'com-bannerSwiperTwo-item-img-leave': !$data.imgIsScale && $data.tabActive == index && $data.actives[index] == slotProps.index,
              'com-bannerSwiperTwo-item-img-hover': $data.imgIsScale && $data.tabActive == index && $data.actives[index] == slotProps.index
            }]),
            width: "100%",
            fit: "cover",
            src: slotProps.item.src
          }, null, 8, ["id", "class", "src"])])])]),
          _: 2
        }, 1032, ["dataArr", "slidesPerView", "initialSlide", "onSlideChangeTransitionStart", "onSlideChangeTransitionEnd"]), _createElementVNode("div", {
          class: _normalizeClass(["com-bannerSwiperTwo-item-content", {
            'text-focus-in': $data.showText
          }])
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          class: "com-bannerSwiperTwo-item-cover-img",
          alt: "",
          src: $data.dataArr[item.name][$data.actives[index]]?.cover
        }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, _toDisplayString($data.dataArr[item.name][$data.actives[index]]?.name.toLocaleUpperCase()), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($data.dataArr[item.name][$data.actives[index]]?.summary.split('\n')[0]), 1), _createElementVNode("div", _hoisted_16, _toDisplayString($data.dataArr[item.name][$data.actives[index]]?.summary.split('\n')[1]), 1)]), _createElementVNode("div", {
          class: "btn-area",
          onClick: $event => $options.toDetail(index)
        }, _toDisplayString($data.lang === 2 ? 'Overview/概述' : 'OVERVIEW'), 9, _hoisted_17)], 2)])]),
        _: 2
      }, 1032, ["title", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["active"])])], 4);
}